import React from 'react'
import { UserRegistrationForm } from '../../form/registerForm/UserRegistrationForm'

export const Register = () => {
  return (
   <>
   <UserRegistrationForm/>
   </>
  )
}
